<template>
  <div class="diagnose">
    <el-dialog title="诊断" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <el-form :model="diagnoseFormData" label-width="100px">
        <el-form-item label="申请时间">
          <el-input v-model="diagnoseFormData.applyCodiagTime"></el-input>
        </el-form-item>

        <el-form-item label="初步诊断">
          <el-input type="textarea" v-model="diagnoseFormData.applyDiagnosis" placeholder="请输入对该患者的初步诊断"></el-input>
        </el-form-item>

        <el-form-item label="发起人">
          <el-input v-model="diagnoseFormData.applyDoctorName"></el-input>
        </el-form-item>

        <el-form-item label="发起机构">
          <el-input v-model="diagnoseFormData.applyHopital"></el-input>
        </el-form-item>

        <el-form-item label="发起科室">
          <el-input v-model="diagnoseFormData.applyDeptName"></el-input>
        </el-form-item>

        <el-form-item label="协诊机构">
          <el-select @change="hospitalChange" v-model="diagnoseFormData.codiagHospital" placeholder="请选择">
            <el-option v-for="item in codiagHospitalOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="协诊科室">
          <el-select v-model="diagnoseFormData.codiagDeptName" placeholder="请选择">
            <el-option v-for="item in codiagDeptNameOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="oneReferral">一键转诊</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getListMyDept, applyCoDiag, getDeptList, getUserInfos } from "@/api/health/Patients";

Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
export default {
  data() {
    return {
      dialogVisible: false,
      diagnoseFormData: {
        applyCodiagTime: null,
        applyDiagnosis: null,
        applyHopital: null,
        applyDeptName: null,
        codiagHospital: null,
        codiagDeptName: null
      },
      patientMsg: null,
      codiagHospitalOptions: [],
      codiagDeptNameOptions: []
    };
  },
  created() {
    this.getSystemTime();
  },
  methods: {
    // 选中机构变化生成科室
    hospitalChange(value) {
      this.codiagDeptNameOptions = [];
      var params = {
        parentId: null
      }
      console.log("协诊机构", value, this.codiagHospitalOptions)
      this.codiagHospitalOptions.forEach((item) => {
        if(item.label == value) {
          params.parentId = item.deptId;
        }
      })
      getDeptList(params).then((res) => {
        if(res.msg == "success") {
          res.data.records.forEach(item => {
            this.codiagDeptNameOptions.push({ label: item.name, value: item.name, deptId: item.deptId })
          })
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    // 初始化组件
    async init(value) {
      console.log("tanchuangxinxi", value);
      console.log("111============", this.$store.getters, this.$store.getters.deptName);
      this.patientMsg = value;
      var params = {
        patientId: value.patientId,
        health_no: value.health_no,
      }
      this.getListDept(params);
      this.getUserInfos();
    },
    // 获取发起人员信息
    getUserInfos() {
      getUserInfos({}).then((res) => {
        if(res.msg == "success") {
          this.diagnoseFormData.applyDoctorName = res.data.name;
          this.diagnoseFormData.applyHopital = res.data.hospitalName;
          this.diagnoseFormData.applyDeptName = res.data.deptName;
          this.$nextTick(() => {
            this.dialogVisible = true;
          })
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    // 获取协诊机构列表
    getListDept(params) {
      this.codiagHospitalOptions = [];
      getListMyDept(params).then(res => {
        if (res.msg == "success") {
          res.data.highHospital.forEach(item => {
            this.codiagHospitalOptions.push({ label: item.name, value: item.name, parentId: item.parentId })
          })
          res.data.lowerHospital.forEach(item => {
            this.codiagHospitalOptions.push({ label: item.name, value: item.name, deptId: item.deptId })
          })
        }
      })
    },
    // 一键转诊
    oneReferral() {
      if (!this.diagnoseFormData.applyDiagnosis) {
        this.$message({
          message: "请输入对该患者的初步诊断！",
          type: "error"
        })
        return;
      }

      if (!this.diagnoseFormData.codiagHospital) {
        this.$message({
          message: "请选择协诊机构！",
          type: "error"
        })
        return;
      }

      if (!this.diagnoseFormData.codiagDeptName) {
        this.$message({
          message: "请选择协诊科室！",
          type: "error"
        })
        return;
      }

      var type = this.codiagDeptNameOptions.some((item) => {
        return item.label == this.diagnoseFormData.codiagDeptName
      })

      if (!type) {
        this.$message({
          message: "该协诊机构暂无此协诊科室，请重新选择！",
          type: "error"
        })
        return;
      }

      this.diagnoseFormData.patientId = this.patientMsg.patientId;
      this.diagnoseFormData.health_no = this.patientMsg.health_no;
      this.diagnoseFormData.refType = "协诊管理";
      params.codiagServiceName = "高血压协诊";

      applyCoDiag(this.diagnoseFormData).then(res => {
        if (res.msg == "success") {
          this.$message({
            message: '转诊成功!',
            type: 'success'
          })
          this.dialogVisible = false;
        } else {
          this.$message({
            message: '转诊失败!',
            type: 'error'
          })
        }
      })
    },
    // 获取系统时间
    getSystemTime() {
      // 实例化日期类
      var time = new Date();
      // 获取完整的年份(4位)
      var year = time.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = time.getMonth();
      // 获取日期(1-31)
      var date = time.getDate();
      var hour = time.getHours();
      var minute = time.getMinutes();
      var second = time.getSeconds();
      //测试打印
      console.log(year + "年" + month + "月" + date + "日 ");
      time.setFullYear(year, month, date);
      time.setHours(hour, minute, second);

      this.diagnoseFormData.applyCodiagTime = time.Format("yyyy-MM-dd hh:mm:ss"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }
}
</style>